import React, {useMemo} from 'react';
import cn from 'classnames';

import {useSearchMgrInstance} from 'coreHooks';

import Contentful from 'brand/app/contentful/components/Contentful';
import {useCategoryContext} from 'brand/app/pages/category/context/CategoryContext';

import {ISearchHitsSubcomponent} from './ISearchHitsSubcomponent';

const ProductsGridCustomElement = ({index, page, pageSize}: ISearchHitsSubcomponent) => {
	const {
		searchType,
		searchInstanceKey,
		customElements,
		customElementsConfigs,
		customElementsHideInSmallGrid
	} = useCategoryContext(true) || {};
	const searchMgr = useSearchMgrInstance({searchType, key: searchInstanceKey});
	const hasActiveFilters = searchMgr.isSomeFilterSelectedByUser() || !!searchMgr.getUserSelectedSorting();
	const customElementIncludes = useMemo(() => {
		const map = new Map();

		customElements?.items?.forEach((c, k) => {
			const productConfig = customElementsConfigs?.items?.[k];

			if (productConfig) {
				map.set(productConfig.position, {
					contentfulData: c,
					size: productConfig.size,
					height: productConfig.height,
					width: productConfig.width,
					position: productConfig.position,
					positionMOB: productConfig.positionMOB,
					sizeMOB: productConfig.sizeMOB,
					hideInSmallGrid: customElementsHideInSmallGrid,
				});
			}
		});

		return map;
	}, [customElements, customElementsConfigs, customElementsHideInSmallGrid]);
	const offset = (page - 1) * pageSize;
	const position = index + offset;
	const customElementInclude = customElementIncludes?.get(position + 1);

	const getClassNames = (element) => cn(
		'element-category-page',
		{
			'element-category-page--hide-on-small-grid': element?.hideInSmallGrid
		},
		`element-category-page__width--${element?.width || 1}`,
		{
			[`element-category-page__height--${element?.height}`]: typeof element?.height === 'number',
		}
	);

	const contentData = useMemo(() => {
		if (!customElementInclude?.contentfulData) {
			return null;
		}

		return {
			...customElementInclude.contentfulData,
			classNames: getClassNames(customElementInclude)
		};
	}, [customElementInclude?.contentfulData, customElementInclude?.width, customElementInclude?.height]);

	if (!customElementInclude) {
		return null;
	}

	if (hasActiveFilters) {
		return null;
	}

	return (
		<Contentful initialData={contentData} />
	);
};

export default ProductsGridCustomElement;
